"use strict";

var appTypes = require('../types/appTypes');
var deviceShellHelper = require('../helper/deviceShellHelper');
var _ = require('underscore');
var util = require('../helper/util');

function doFindComID(controlsNode, ID) {
  var i;
  var itemNode;
  var childNodeResult;

  for (i = 0; i < controlsNode.length; i++) {
    itemNode = controlsNode[i];
    if (itemNode.controlID === ID) {
      return itemNode;
    }

    if (itemNode.items !== undefined) {
      childNodeResult = doFindComID(itemNode.items, ID);//这里必须要传ID
      if (childNodeResult !== null) {
        return childNodeResult;
      }
    }
  }

  return null;
}


exports.findComInGroupByID = function (groupNode, comID) {
  if (groupNode && groupNode.items) {
    return doFindComID(groupNode.items, comID);
  }
  return null;
};


exports.findComInGroupByAlias = function (groupNode, alias) {
  var fx = function (groupNode, alias) {
    var item;
    var i = 0;
    var l = groupNode.items.length;
    for (i; i < l; i++) {
      item = groupNode.items[i];
      if (item.alias === alias) {
        return item;
      } else {
        if (item.items) {
          return fx(item, alias);
        }
      }
    }
    return null;
  };
  if (groupNode.items) {
    return fx(groupNode, alias);
  }
  return null;
};

/**
 * 根据组件ID号获取组件json数据
 * @param pageData 页面文档根节点数据
 * @param ID 带查找的组件ID
 */
function getControlDataByComID(pageData, ID) {
  var controlsNode = pageData.controls;
  if ((controlsNode.control === undefined) || (ID === '')) {
    return null;
  }

  return doFindComID(controlsNode.control, ID);
}

exports.getComAbsoluteRect = function (pageData, comp) {

  function getChildByID(_comp, childID) {
    var c;
    var i = 0;
    if (_comp.items) {
      for (i; i < _comp.items.length; i++) {
        c = _comp.items[i];
        if (c.controlID === childID) {
          return c;
        }
      }
    }
    return null;
  }

  function doGet(_comp) {
    if (_comp) {
      rect.left += parseInt(_comp.x, 10);
      rect.top += parseInt(_comp.y, 10);
      rect.right = rect.left + parseInt(_comp.w, 10);
      rect.bottom = rect.top + parseInt(_comp.h, 10);
      index++;
      if (index < pathStr.length) {
        _comp = getChildByID(_comp, pathStr[index]);
        doGet(_comp);
      }
    }
  }

  var path = comp.parentPath;
  var rect;
  var pathStr;
  var index = 0;
  if (!path) {
    path = comp.controlID;
  } else {
    path += (',' + comp.controlID);
  }
  if (path) {
    rect = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    pathStr = path.split(',');
    doGet(getControlDataByComID(pageData, pathStr[0]));
  }
  return rect;
};

exports.updatePageComData = function (pageData, newComData) {
  function doUpdate(controls) {
    var i;
    var controlNode;

    for (i = 0; i < controls.length; i++) {
      controlNode = controls[i];
      if (controlNode.controlID === newComData.controlID) {
        controls[i] = newComData;
        return;
      } else {
        if (controlNode.items) {
          doUpdate(controlNode.items);
        }
      }
    }
  }

  if (pageData.controls) {
    doUpdate(pageData.controls.control);
  }
};

exports.updateComData = function (pageData, comID, propertyName, value) {
  var com = getControlDataByComID(pageData, comID);
  if (com) {
    com[propertyName] = value;
  }
};

exports.getControlDataByComID = getControlDataByComID;

/**
 * 判断当前组件是否为交互数据中不可见组件
 * @param typeID
 * @constructor
 * @return {boolean}
 */
function IsInvisualInteractiveCom(typeID) {

  //
  // 目前包含5个组件为不可见交互类型组件，弹出面板，提示面板，弹出面板，抽屉。
  //

  return (typeID === 'PopupPanel') || (typeID === 'HoverPanel') || (typeID === 'AlertWindow') ||
    (typeID === 'PopupMenu') || (typeID === 'SlidingDrawer');
}

exports.IsInvisualInteractiveCom = IsInvisualInteractiveCom;

function doGetSkipPageID(comArray, pageIDs) {
  var i;
  var com;
  var links;
  var link;
  var iLink;

  for (i = 0; i < comArray.length; i++) {
    com = comArray[i];
    if (com.links && com.links.link) {
      links = com.links.link;
      for (iLink = 0; iLink < links.length; iLink++) {
        link = links[iLink];
        if (link.targetPageID && link.linkType === appTypes.PageLinkType.PAGE_LINK) {
          if (pageIDs.indexOf(link.targetPageID) === -1)
            pageIDs.push(link.targetPageID);
        }
      }
    }

    if (com.items) {
      doGetSkipPageID(com.items, pageIDs);
    }
  }
}

/**
 * 获取页面中所有目标页面ID
 * @param controls ：页面controls根节点
 */
exports.getAllSkipPageID = function (controls) {
  var resultPageIDs = [];
  var comArray;

  if (controls) {
    comArray = controls.control;
    if (comArray) {
      doGetSkipPageID(comArray, resultPageIDs);
    }
  }

  return resultPageIDs;
};

exports.getPageDeviceMetaInfo = function (page, projectMeta, shell) {
  var isHorizontal;
  var shellSize;
  var shellWidth;
  var shellHeight;
  var pagePosition;
  var defaultPageSize;

  defaultPageSize = util.Point.strToPoint(projectMeta.pageSize);

  if (['iPhone', 'Android', 'Tablet', 'iPad'].indexOf(shell) !== -1) {
    isHorizontal = page.screenOrientation !== appTypes.ScreenOrientation.PORTRAIT;
    if (page.screenOrientation !== projectMeta.orientation) {
      defaultPageSize = {
        x: defaultPageSize.y,
        y: defaultPageSize.x
      };
    }

    shellSize = deviceShellHelper.getShellComponentSize(shell, isHorizontal);
    shellWidth = (defaultPageSize.x * shellSize.width) / shellSize.screenWidth;
    shellHeight = (defaultPageSize.y * shellSize.height) / shellSize.screenHeight;

    // 页面相对于device Position位置
    pagePosition = {
      x: (shellWidth - defaultPageSize.x) / 2,
      y: (shellHeight - defaultPageSize.y) / 2
    };

  } else if (shell === 'desktop') {

    defaultPageSize = {
      x: parseInt(page.measureW, 10),
      y: parseInt(page.measureH, 10)
    };

    // 桌面项目，上边距30个像素，左，右，下，8个像素
    shellWidth = defaultPageSize.x + 2 * 8;
    shellHeight = defaultPageSize.y + 8 + 30;

    pagePosition = {
      x: 8,
      y: 30
    };

  } else {
    // 计算自由项目，网页项目，空白项目工作区尺寸宽度与高度。
    // 目前的方式中，还包含了桌面项目的，此时桌面项目没有包含外边边框。

    shellWidth = defaultPageSize.x;
    shellHeight = defaultPageSize.y;

    pagePosition = {
      x: 0,
      y: 0
    };
  }

  if (projectMeta.platform === 'MtWeb' || projectMeta.platform === 'MtCustom') {
    shellWidth = parseInt(page.measureW, 10);
    shellHeight = parseInt(page.measureH, 10);
    defaultPageSize = {
      x: shellWidth,
      y: shellHeight
    };
  }

  return {
    width: Math.round(shellWidth),
    height: Math.round(shellHeight),
    position: {
      x: Math.round(pagePosition.x),
      y: Math.round(pagePosition.y)
    },
    pageSize: {
      x: Math.round(defaultPageSize.x),
      y: Math.round(defaultPageSize.y)
    },
    isHorizontal: isHorizontal
  };
};

exports.getPageDeviceMetaInfoForFullPage = function (page, projectMeta, shell) {
  var isHorizontal;
  var shellSize;
  var shellWidth;
  var shellHeight;
  var pagePosition;
  var defaultPageSize;

  defaultPageSize = util.Point.strToPoint(page.measureW + ',' + page.measureH);

  if (['iPhone', 'Android', 'Tablet', 'iPad'].indexOf(shell) !== -1) {
    isHorizontal = page.screenOrientation !== appTypes.ScreenOrientation.PORTRAIT;
    if (page.screenOrientation !== projectMeta.orientation) {
      defaultPageSize = {
        x: defaultPageSize.y,
        y: defaultPageSize.x
      };
    }

    shellSize = deviceShellHelper.getShellComponentSize(shell, isHorizontal);
    shellWidth = (defaultPageSize.x * shellSize.width) / shellSize.screenWidth;
    shellHeight = (defaultPageSize.y * shellSize.height) / shellSize.screenHeight;

    // 页面相对于device Position位置
    pagePosition = {
      x: (shellWidth - defaultPageSize.x) / 2,
      y: (shellHeight - defaultPageSize.y) / 2
    };

  } else if (shell === 'desktop') {

    defaultPageSize = {
      x: parseInt(page.measureW, 10),
      y: parseInt(page.measureH, 10)
    };

    // 桌面项目，上边距30个像素，左，右，下，8个像素
    shellWidth = defaultPageSize.x + 2 * 8;
    shellHeight = defaultPageSize.y + 8 + 30;

    pagePosition = {
      x: 8,
      y: 30
    };

  } else {
    // 计算自由项目，网页项目，空白项目工作区尺寸宽度与高度。
    // 目前的方式中，还包含了桌面项目的，此时桌面项目没有包含外边边框。

    shellWidth = defaultPageSize.x;
    shellHeight = defaultPageSize.y;

    pagePosition = {
      x: 0,
      y: 0
    };
  }

  if (projectMeta.platform === 'MtWeb' || projectMeta.platform === 'MtCustom') {
    shellWidth = parseInt(page.measureW, 10);
    shellHeight = parseInt(page.measureH, 10);
    defaultPageSize = {
      x: shellWidth,
      y: shellHeight
    };
  }

  return {
    width: Math.round(shellWidth),
    height: Math.round(shellHeight),
    position: {
      x: Math.round(pagePosition.x),
      y: Math.round(pagePosition.y)
    },
    pageSize: {
      x: Math.round(defaultPageSize.x),
      y: Math.round(defaultPageSize.y)
    },
    isHorizontal: isHorizontal
  };
};

exports.getMobileDeviceMetaInfo = function (page, projectMeta) {

  var isHorizontal;
  var defaultPageSize;

  defaultPageSize = util.Point.strToPoint(projectMeta.pageSize);

  if (projectMeta.platform === appTypes.AppPlatformType.PAD || projectMeta.platform === appTypes.AppPlatformType.MOBILE) {
    isHorizontal = page.screenOrientation !== appTypes.ScreenOrientation.PORTRAIT;
    if (page.screenOrientation !== projectMeta.orientation) {
      defaultPageSize = {
        x: defaultPageSize.y,
        y: defaultPageSize.x
      };
    }
  }


  return {
    pageSize: defaultPageSize,
    isHorizontal: isHorizontal
  };
};

function getLinkAreaArray(componentData) {
  var i;
  var link;
  var linkItem;
  var resultLinkArray = [];

  var entry;
  var events;

  if (componentData.link && componentData.links.link) {

    for (i = 0; i < componentData.links.link.length; i++) {
      link = componentData.links.link[i];
      linkItem = {};

      if (link.targetPageID && link.linkType === appTypes.PageLinkType.PAGE_LINK) {
        linkItem.index = i;
        linkItem.linkCoords = link.area.coores;
      }

      if (componentData.interactiveData) {
        entry = componentData.interactiveData.entry[i];
        if (entry) {
          events = entry.events;
          if (events && events.event && events.event.length) {
            linkItem.index = i;
            linkItem.interactiveCoords = entry.area.coords;
          }
        }
      }


      if (!_.isEmpty(linkItem)) {
        resultLinkArray.push(linkItem);
      }

    } // for
  }

  return resultLinkArray;

}

function parseSingleComponentLinkArray(componentData) {
  var i;
  var itemsArray;
  var itemLength;

  componentData.linkArrays = getLinkAreaArray(componentData);

  if (componentData.items) {

    itemsArray = componentData.items;
    itemLength = itemsArray.length;

    for (i = 0; i < itemLength; i++) {
      itemsArray[i] = parseSingleComponentLinkArray(componentData.items[i]);
    }

  }

  return componentData;

}

exports.afterLoadPrepareDataStructure = function (page) {
  var i = 0;
  var arrayLength;

  if (page.controls.control) {
    arrayLength = page.controls.control.length;

    for (i = 0; i < arrayLength; i++) {
      page.controls.control[i] = parseSingleComponentLinkArray(page.controls.control[i]);
    }

  }

  return page;

};




// WEBPACK FOOTER //
// ./src/helper/pageHelper.js